export const INVITE_VERIFICATION_REQUEST = "INVITE_VERIFICATION_REQUEST"
export const INVITE_VERIFICATION_SUCCESS = "INVITE_VERIFICATION_SUCCESS"
export const INVITE_VERIFICATION_FAILURE = "VERIFICATION_FAILURE"

export const INVITE_VERIFICATION_ERROR_CLEAR = "INVITE_VERIFICATION_ERROR_CLEAR"